import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const styles = {
  button: {
    padding: '0px 15px',
    backgroundColor: '#D8EBFF',
    borderRadius: 12,
    border: 'none',
    color: '#2196F3',
    fontSize: 14,
    fontWeight: 'bold',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#99c2ec',
      color: '#025394'
    }
  }
};

const enhance = compose();

const button = enhance(({ classes, linkToCopy }) => {
  return (
    <CopyToClipboard text={linkToCopy}>
      <Button
        variant="contained"
        color="secondary"
        className={classes.button}
        tabIndex="-1"
      >
        リンクをコピー
      </Button>
    </CopyToClipboard>
  );
});

export default withRouter(withStyles(styles)(button));
